import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ADMIN_SLUG } from "@/lib/adminPath";

const KEY = "pj_visitor_id";

const visitorId = () => {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = `v_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
};

/** 15-second heartbeat so the ops console can show who is on the site right now. */
export const usePresence = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const path = useRef(pathname);
  path.current = pathname;
  const uid = useRef("");
  uid.current = user?.id || "";

  useEffect(() => {
    const isOps = ADMIN_SLUG && (pathname.startsWith(`/${ADMIN_SLUG}`) || pathname.startsWith("/ops/"));
    if (isOps) return;

    let timer;
    const beat = () => {
      if (document.visibilityState === "hidden") return;
      api
        .post("/presence/ping", {
          visitor_id: visitorId(),
          path: path.current,
          referrer: document.referrer || "",
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
          user_id: uid.current,
        })
        .catch(() => {});
    };
    beat();
    timer = setInterval(beat, 15000);
    return () => clearInterval(timer);
  }, [pathname]);
};
